(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabObjectTypesDetailController', TabObjectTypesDetailController);

    TabObjectTypesDetailController.$inject = ['$scope', '$rootScope', 'entity'];

    function TabObjectTypesDetailController($scope, $rootScope, entity) {
        var vm = this;
        vm.tabObjectTypes = entity;

        var unsubscribe = $rootScope.$on('jotApp:tabObjectTypesUpdate', function(event, result) {
            vm.tabObjectTypes = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
